var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cardPicture"},[_c('Picture',{attrs:{"src":_vm.src,"preasigned":_vm.preasigned,"alt":_vm.alt}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }